import React from 'react';
import PropTypes from 'prop-types';

// Components
import Form from '../../../../../../../../../../components/Form';
import { Button } from '../../../../../../../../../../components/Button';
import { Dialog } from '../../../../../../../../../../components/Dialog';
import { DialogHeader } from '../../../../../../../../../../components/DialogHeader';
import { DialogBody } from '../../../../../../../../../../components/DialogBody';
import { DialogFooter } from '../../../../../../../../../../components/DialogFooter';

// Utils
import {
    translateUIConfigForAddEdit,
    translateFormDataForReadOnlyForm
} from '../../../../../../../../../../common/utility';

export const CodeConceptFormModal = ({ closeDialog, data, uiConfig, title }) => {
    const documentState = React.useMemo(() => {
        return translateFormDataForReadOnlyForm({ uiConfig, data });
    }, [data]);
    const formModel = translateUIConfigForAddEdit(uiConfig);
    const onApplyFormState = () => {};

    return (
        <Dialog close={closeDialog} size="full" visible id="criteria-manager-code-table-modal">
            <DialogHeader close={closeDialog}>{title}</DialogHeader>
            <DialogBody style={{ paddingBottom: 0 }}>
                <Form
                    formModel={formModel}
                    data={documentState}
                    errors={{}}
                    compose={false}
                    onApplyFormState={onApplyFormState}
                    setEdited={() => {}}
                    fatalError={null}
                />
            </DialogBody>
            <DialogFooter>
                <Button text appearance="secondary" onClick={closeDialog}>
                    Cancel
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

export default CodeConceptFormModal;

CodeConceptFormModal.propTypes = {
    title: PropTypes.string,
    data: PropTypes.object,
    uiConfig: PropTypes.object,
    closeDialog: PropTypes.func
};
